<template lang="pug">
  v-list(class="menu-list py-0")
    v-list-item(
      v-for="(action, idx) in actions"
      :key="idx"
      @click="action.call(target)"
      class="menu-list__item"
    )
      v-list-item-title(
        class="text-14px light"
        :class="[isRemoveAction(action) ? 'color-error' : 'dark']"
      ) {{ $t(action.text) }}
      v-list-item-icon(
        v-if="action.icon"
        class="ma-0 h-100 d-flex align-center"
      )
        e-svg-icon(:name="action.icon")
</template>

<script>
export default {
  name: 'MListActions',
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    target: {
      type: Object,
      default: null
    }
  },
  methods: {
    isRemoveAction(action) {
      return ['delete', 'remove'].includes(action.name)
    }
  }
}
</script>

<style scoped lang="scss"></style>
